import { getFullFieldPath } from '../../utils';

import { INTEGRATIONS_TAB_KEY } from './constants';

export const getFullIntegrationsPath = (fieldId) => getFullFieldPath(INTEGRATIONS_TAB_KEY, fieldId);
